//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginLayer from "./login/loginLayer";
// const Cookie = process.client ? require("js-cookie") : undefined;
export default {
  components: {LoginLayer},
  props: ["pageName", "isLogin"],
  data(){
    return {
      inMail: "", // 未读站内信数量
      typeName: 'indexLogin',
      isSmallScreen: false
    }
  },
  computed:{
    menuDataRes () {
      const userInfo = this.$store.state.user;
      /** 角色配置菜单
       * 1： 商标查询   2：商品/服务分类  3：商标对比   4：商标分析  5：商标公告
       * 6：裁定文书    8：商标监控   10：商标图形  11：业务线索    12：品牌风险
       * 13：专项查询   14：文书撰写  14-2：AI驳回撰写 14-4: AI撤三撰写
       * */
      /*
      * uc_vip_level: 1 个人版  2专业版  11员工 21免费试用  31公司客户
      * uc_memberType: 1代理人  2申请人 3 超凡内部员工    4其他
      * */
      let data = [];
      const menuData = this.tools.menuData; // 首页不显示“AI驳回撰写”菜单
      // 首页不显示“AI驳回撰写”菜单
     /* const menuData = this.tools.menuData.map(item => {
        const newItem = { ...item };
        if(newItem.index === '14' && newItem.subRoute){
          // 从index为14的项中过滤掉index为14-2的子项
          newItem.subRoute = newItem.subRoute.filter(subItem => subItem.index !== '14-2' && subItem.index !== '14-4')
        }
        return newItem;
      });*/
      if(userInfo){
        if(userInfo.uc_memberType === 1 || userInfo.uc_memberType === 3) { // 代理人
          data = menuData.filter( item => item.index !== '12');
        } else if(userInfo.uc_memberType === 2 || userInfo.uc_memberType === 4){
          data = menuData.filter( item => item.index !== '11');
        } else {
          data = menuData;
        }
      } else {
        data = menuData.filter( item => item.index !== '12');
      }

      /*if(userInfo && userInfo.uc_vip_level == 1){  // 个人版  [1,2,3,5,6]
        let hasMenus = ['1','2','3','5','6']
        data = this.tools.menuData.filter(item => hasMenus.indexOf(item.index) > -1)
      } else if(userInfo && userInfo.uc_vip_level === 21) { // 免费试用
        data = this.tools.menuData.filter( item => item.index !== '9' && item.index !== '8');
      } else { // 其他版本 -- 菜单都显示（只限制次数）
        data = this.tools.menuData.filter( item => item.index !== '9');
        if(userInfo && userInfo.uc_memberType === 1) { // 代理人
          data = this.tools.menuData.filter( item => item.index !== '9' && item.index !== '12');
        }
        if(userInfo && userInfo.uc_memberType === 2) {// 申请人
          data = this.tools.menuData.filter( item => item.index !== '9' && item.index !== '11');
        }
        if(userInfo && userInfo.uc_memberType === 4) { // 其他
          data = this.tools.menuData.filter( item => item.index !== '11');
        }
      }*/
      return data
    },
    activeMenu(){
      return this.$route.path
    },
    showLoginLayer: {
      get() {
        return this.$store.state.showLoginLayer;
      },
      set(value) {
        this.$store.commit('SET_LOGIN_VISIBLE', value);
      }
    }
  },
  watch:{
    isLogin(newVal){
      if(newVal) this.getNoticeNumber()
    }
  },
  async mounted() {
    this.showLoginLayer = false;
    this.getNoticeNumber();
    this.checkScreenWidth(); // 2. 初始化调用
    window.addEventListener('resize', this.checkScreenWidth); // 3. 绑定事件
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth); // 4. 清理事件
  },
  methods: {
    checkScreenWidth() {
      this.isSmallScreen = window.innerWidth < 1400;
    },
    // 点击登录
    handleLogin(){
      this.typeName = 'indexLogin'
      this.$store.commit('SET_LOGIN_VISIBLE', true);
    },
    // 点击注册
    handleReg(){
      this.typeName = 'indexReg'
      this.$store.commit('SET_LOGIN_VISIBLE', true);
    },
    /*// 退出登录
    handleLogout(){
      localStorage.removeItem("uc_token");
      // Cookie.remove("searchKeyword");
      this.$cookies.remove("searchKeyword");
      //退出登录
      this.$axios.post("/api/auth/logout").then(res => {
        this.$store.commit("setUser", null);
        this.$router.push("/");
      });
    },*/
    // 关闭登录弹窗
    closeLogin(type) {
      if(type === 'refresh'){
        window.location.reload(); // 刷新当前页面
      }
      this.$store.commit('SET_LOGIN_VISIBLE', false);
    },
    // 开通会员
    goVersionIntroduction(){
      this.$router.push({
        path:"/user/VersionIntroduction",
      })
    },
    // 关于我们
    goAboutWe(){
      this.$router.push({
        path:"/user/About",
      })
    },
    // 商标百科
    goTmWiki(){
      this.$router.push({
        path:"/tmWiki",
      })
    },
    goRoute(vc){
      if(vc.index === '/trademarkSearch'){ // 存cookie，显示初始查询页面
        this.$cookies.set("showInto", true)
      }
      if(vc.index === '/trademarkSearchInternational'){ // 存cookie，显示初始查询页面
        this.$cookies.set("showInterInto", true)
      }
      this.$router.push(vc.index)
    },
    getNoticeNumber(){
      if(!this.isLogin) return
      this.$axios.get("/api/Member/getNoticeNumber", {
        params: { id: Math.random() }
      }).then(res => {
        let _data = res.data.data;
        if (_data) {
          this.inMail = _data.inMail;
        }
      })
    }
  }

};
